import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '@app/app.reducers';

import { PromoCampaignItem } from '@shared/models/DigitalPromo';
import { formatDate } from '@shared/utils';

@Component({
  selector: 'app-promo-campaign',
  styleUrls: ['../promo-banner/promo-banner.component.scss', './promo-campaign.component.scss'],
  templateUrl: './promo-campaign.component.html',
  standalone: false
})
export class PromoCampaignComponent implements OnInit, OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  loading: false;
  id: string;
  campaign: PromoCampaignItem;
  currency: string;
  language: string;
  highestAmount: number;
  endDate: string;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private router: Router,
    private translateService: TranslateService
  ) {
    this.route.paramMap.subscribe((params) => {
      if (params.has('id')) {
        this.id = params.get('id').valueOf();
      }
    });
    this.store.pipe(select(fromAppRoot.selectPromoCampaigns), takeUntil(this.onDestroy$)).subscribe((campaigns) => {
      if (!campaigns || !campaigns.length) {
        return;
      }
      const campaign = campaigns.find((campaign) => campaign.id === this.id);
      if (campaign) {
        this.campaign = campaign;
        this.highestAmount = Math.max(...campaign.promotions.map((o) => o.attributes.value));
        this.endDate = formatDate(campaign.attributes.end_date, '-', this.translateService.currentLang);
      }
    });
    this.store
      .pipe(select(fromAppRoot.selectCustomerAndCurrentAccount), takeUntil(this.onDestroy$))
      .subscribe(({ customer, currentAccountDetail }) => {
        this.currency = currentAccountDetail.currency;
        this.language = customer.language;
      });
  }

  ngOnInit(): void {
    this.store.dispatch(AppRootActions.getPromoCampaigns());
  }

  participate(participation: boolean): void {
    this.store.dispatch(AppRootActions.setCampaignParticipation({ participation, id: Number(this.campaign.id) }));
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
